import React from 'react';
import './SendingProgress.css';

const SendingProgress = ({ campaign, status, onPause, onResume }) => {
  if (!status) {
    return (
      <div className="sending-progress-container">
        <div className="loading-spinner"></div>
        <p>Carregando status da campanha...</p>
      </div>
    );
  }
  
  const progress = status.totalRecipients > 0 
    ? Math.round((status.sentCount / status.totalRecipients) * 100)
    : 0;
    
  const isPaused = status.status === 'paused';
  const isCompleted = status.status === 'completed';
  const isFailed = status.status === 'failed';
  
  const getStatusColor = () => {
    if (isFailed) return '#e74c3c';
    if (isCompleted) return '#27ae60';
    if (isPaused) return '#f39c12';
    return '#3498db';
  };
  
  const getStatusText = () => {
    if (isFailed) return 'Falhou';
    if (isCompleted) return 'Concluído';
    if (isPaused) return 'Pausado';
    return 'Enviando';
  };
  
  const formatTime = (date) => {
    return new Date(date).toLocaleString('pt-BR');
  };
  
  const getElapsedTime = () => {
    const start = new Date(status.createdAt);
    const now = new Date();
    const diff = Math.floor((now - start) / 1000);
    
    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;
    
    if (hours > 0) {
      return `${hours}h ${minutes}m ${seconds}s`;
    } else if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    } else {
      return `${seconds}s`;
    }
  };
  
  return (
    <div className="sending-progress-container">
      <div className="progress-header">
        <h2>Progresso do Envio</h2>
        <div className="campaign-info">
          <span className="campaign-name">{status.name}</span>
          <span className={`status-badge ${status.status}`} style={{ backgroundColor: getStatusColor() }}>
            {getStatusText()}
          </span>
        </div>
      </div>
      
      <div className="progress-stats">
        <div className="stat-item">
          <span className="stat-label">Emails Enviados</span>
          <span className="stat-value">{status.sentCount} / {status.totalRecipients}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Falhas</span>
          <span className="stat-value" style={{ color: status.failedCount > 0 ? '#e74c3c' : 'inherit' }}>
            {status.failedCount}
          </span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Tempo Decorrido</span>
          <span className="stat-value">{getElapsedTime()}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Lote Atual</span>
          <span className="stat-value">{status.currentBatch || '-'}</span>
        </div>
      </div>
      
      <div className="progress-bar-container">
        <div className="progress-bar">
          <div 
            className="progress-fill"
            style={{ 
              width: `${progress}%`,
              backgroundColor: getStatusColor()
            }}
          />
        </div>
        <span className="progress-percentage">{progress}%</span>
      </div>
      
      {!isCompleted && !isFailed && (
        <div className="progress-actions">
          {isPaused ? (
            <button 
              className="action-button resume"
              onClick={() => onResume(status._id)}
            >
              ▶ Retomar Envio
            </button>
          ) : (
            <button 
              className="action-button pause"
              onClick={onPause}
            >
              ⏸ Pausar Envio
            </button>
          )}
        </div>
      )}
      
      {status.error && (
        <div className="error-details">
          <h4>Detalhes do Erro:</h4>
          <p>{status.error}</p>
        </div>
      )}
      
      {status.recipients && status.recipients.length > 0 && (
        <div className="recipients-log">
          <h4>Log de Envio</h4>
          <div className="log-entries">
            {status.recipients
              .filter(r => r.sentAt || r.error)
              .slice(-10)
              .reverse()
              .map((recipient, index) => (
                <div key={index} className={`log-entry ${recipient.status}`}>
                  <div className="log-info">
                    <span className="recipient-identifier">{recipient.identifier}</span>
                    <span className="recipient-email">{recipient.email}</span>
                  </div>
                  <div className="log-status">
                    {recipient.status === 'sent' ? (
                      <span className="success">✓ Enviado</span>
                    ) : (
                      <span className="error">✗ Falhou</span>
                    )}
                    {recipient.sentAt && (
                      <span className="timestamp">{formatTime(recipient.sentAt)}</span>
                    )}
                  </div>
                  {recipient.error && (
                    <div className="log-error">{recipient.error}</div>
                  )}
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SendingProgress;